import React, {createContext, useContext} from 'react'

type PlpServerDataContextType = {
    serverCategoryName: string | null
}

const PlpServerDataContext = createContext<PlpServerDataContextType>({
    serverCategoryName: null
})

export const usePlpServerData = () => useContext(PlpServerDataContext)

export const PlpServerDataProvider = ({
    serverCategoryName,
    children
}: {
    serverCategoryName: string | null
    children: React.ReactNode
}) => (
    <PlpServerDataContext.Provider value={{serverCategoryName}}>
        {children}
    </PlpServerDataContext.Provider>
)
